import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ensureAnalytics, trackPageView } from '../lib/consent';

// Loads Analytics once after consent and sends page views on route changes
// (no duplicates — same path tracked only once per page load).
const RouteTracker = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        ensureAnalytics();
    }, []);

    useEffect(() => {
        trackPageView(pathname);
    }, [pathname]);

    return null;
};

export default RouteTracker;
